module.exports = __webpack_public_path__ + "img/code.c284f3d9.png";